import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axiosInstance';
import { toast } from 'sonner';

const t = (name, fn) =>
  createAsyncThunk(name, async (arg, { rejectWithValue }) => {
    try { return await fn(arg); }
    catch (err) {
      toast.error(err.response?.data?.message || err.message);
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  });

export const fetchColors = t('color/fetchAll', async () => {
  const { data } = await api.get('Colors');
  return data.data;
});

export const createColor = t('color/create', async (dto) => {
  const { data } = await api.post('Colors', dto);
  toast.success('Color added');
  return data.data;
});

export const deleteColor = t('color/delete', async (id) => {
  await api.delete(`Colors/${id}`);
  toast.success('Color deleted');
  return id;
});

const colorSlice = createSlice({
  name: 'color',
  initialState: { items: [], loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchColors.pending, (s) => { s.loading = true; })
      .addCase(fetchColors.fulfilled, (s, a) => { s.loading = false; s.items = a.payload || []; })
      .addCase(fetchColors.rejected, (s) => { s.loading = false; })
      .addCase(createColor.fulfilled, (s, a) => { s.items = [...s.items, a.payload]; })
      .addCase(deleteColor.fulfilled, (s, a) => {
        s.items = s.items.filter(c => c.colorId !== a.payload);
      });
  }
});

export default colorSlice.reducer;